<!-- 申请意向备注 -->
<template>
  <div>
    <zlr-modal v-model="remarksModal"
               class="choose-intention-remark">
      <div class="container">
        <h1 class="title">申请意向 - 意向反馈</h1>
        <div class="remarks-detail">
          <div>
            学校：{{detail.overseasBasicInfo && detail.overseasBasicInfo.univer}}
          </div>
          <div>
            项目：{{detail.overseasBasicInfo && detail.overseasBasicInfo.name}}
          </div>
        </div>
        <template v-if="!hasFeedback">
          <div>
            <Form ref="formValidate"
                  :model="formValidate"
                  :rules="ruleValidate">
              <FormItem prop="purposeFeedback">
                <div slot="label">
                  请填写为什么您想要申请该学校的原因
                </div>
                <Input v-model="formValidate.purposeFeedback"
                       placeholder="Please limit your response to 200 words"
                       type="textarea"
                       :rows=6></Input>
              </FormItem>
            </Form>
            <div class="remark-btn">
              <Button type="default"
                      class="zlr-btn-default"
                      @click="handleClose">关闭</Button>
              <Button type="primary"
                      class="zlr-btn-primary"
                      v-if="isallowedit"
                      @click="handleSub">确认</Button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="remarks-detail">
            <div>
              <pre>{{detail.purposeFeedback}}</pre>
            </div>
            <div class="remark-btn"
                 style="text-align:left;">
              <Button type="default"
                      class="zlr-btn-default"
                      @click="remarksModal = false">关闭</Button>
            </div>
          </div>
        </template>
      </div>

    </zlr-modal>
  </div>
</template>

<script>
// API
import { subItemFeedbackModify } from '@/api/preproject'
// components
import ZlrModal from '_c/modal/modal'
// validator
import { validateWordsNum } from '@/libs/validator'

import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: '',
  mixins: [isAllowEdit],
  props: ['detail', 'hasFeedback'],
  components: {
    ZlrModal
  },
  data () {
    return {
      remarksModal: false,
      formValidate: {
        purposeFeedback: ''
      },
      ruleValidate: {
        purposeFeedback: [{ required: true, message: '请填写原因' }, { validator: validateWordsNum, wordsNum: 200 }]
      }
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 显示
    handleShow () {
      this.remarksModal = true
    },
    // 关闭备注
    handleClose () {
      this.$refs['formValidate'].resetFields()
      this.remarksModal = false
    },
    // 提交备注
    handleSub () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let params = {
            purposeFeedback: this.formValidate.purposeFeedback,
            id: this.detail.id
          }
          subItemFeedbackModify(params).then(res => {
            this.handleClose()
            this.$emit('on-change')
          }).catch((error) => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    }
  },
  watch: {
    detail: {
      handler (newValue) {
        this.formValidate = {
          purposeFeedback: newValue.purposeFeedback
        }
      },
      deep: true
    }
  }
}
</script>
<style lang='less' scoped>
</style>
